import { Box } from '@mui/material';

type OriginDotKind = 'process' | 'person';

const ORIGIN_COLORS: Record<OriginDotKind, string> = {
  process: 'secondary.main',
  person: 'info.main',
};

const OriginDot = ({ kind }: { kind: OriginDotKind }) => (
  <Box
    component="span"
    aria-hidden
    sx={{
      display: 'inline-block',
      width: 8,
      height: 8,
      marginRight: 0.5,
      borderRadius: '50%',
      backgroundColor: ORIGIN_COLORS[kind],
    }}
  />
);

export default OriginDot;
